import { useMemo } from 'react';
import { format } from 'date-fns';

import { timeFormat } from '@sternum/web/config';

import { TimelineSystemProps } from '../TimelineGraph.types';

import { Line, TimeSeparatorStyled, Title } from './TimeSeparator.styles';

export interface TimeSeparatorProps extends TimelineSystemProps {
  date: Date;
  dateFormat?: string;
}

export function TimeSeparator({ date, dateFormat = timeFormat.long, ...props }: TimeSeparatorProps) {
  const formattedDate = useMemo(() => {
    return format(date, dateFormat);
  }, [date, dateFormat]);

  return (
    <TimeSeparatorStyled {...props}>
      <Line />
      <Title>{formattedDate}</Title>
    </TimeSeparatorStyled>
  );
}
